var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPercentage = function SvgPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.175 1.265a1 1 0 0 1 .065 1.41l-11 12a1 1 0 1 1-1.475-1.35l11-12a1 1 0 0 1 1.41-.06ZM13 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-4a3 3 0 1 1 0 5.999A3 3 0 0 1 13 10ZM2 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm4 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })));
};
export default SvgPercentage;